import React from 'react';
import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {BuilderNewPlanForm} from './BuilderNewPlanForm';
import OWNERSHIP from '../../../constants/Ownership';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {
  useDeriveIsLowesPension,
  useDeriveIsTransactBond,
} from '../hooks/builderSetUpNewHooks';
import {SelectOption, SelectGroupOption} from '../../../components/AutoForm/AutoFieldNew';
import {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';

const FORMIK_KEY_PREFIX = 'setUpNew';

const getNewPlanTitle = (mainPlanType: string) => {
  switch (mainPlanType) {
    case 'isa':
      return 'An ISA';
    case 'jisa':
      return 'A JISA';
    case 'jsipp':
      return 'A Junior SIPP';
    case 'gia':
      return 'A GIA';
    default:
      return `A ${mainPlanType}`;
  }
};

interface SetUpNewParentProps {
  contactName: string;
  productProvidersOptionGroups: SelectGroupOption<string>[];
  productProviders: PlanProviderSelectOption[] | undefined;
  productNames: SelectOption<string>[] | undefined;
}

export const SetUpNewParent: React.FC<SetUpNewParentProps> = ({
  contactName,
  productProvidersOptionGroups,
  productProviders,
  productNames,
}) => {
  const {values} = useAutoForm<builderFieldsType>();
  const {isSPPDA} = useBuilderContext();
  const {mainPlanType, goal} = values;
  const goalText = isSPPDA ? '' : `- Associated goal: ${goal?.name || 'N/A'}`;

  const isLowesPension = useDeriveIsLowesPension(mainPlanType);
  const isTransactBond = useDeriveIsTransactBond(mainPlanType);

  const {bgClass} = usePlanValidationLevel(FORMIK_KEY_PREFIX);

  const displayName =
    values?.contact === OWNERSHIP.JOINT_CODE ? OWNERSHIP.JOINT_LIVES : contactName;

  return (
    <PlanRow id="notused" reccId={null} isSelected isSubplan={false} sameReview={false}>
      <PlanAccordionShell
        expanded
        isSelected
        isSoleParent={(values.setUpNew?.subplans?.length ?? 0) === 0}
        validationLevel={bgClass}
        summaryChildren={
          <Typography>
            {`${
              getNewPlanTitle(mainPlanType as string) || ''
            } for ${displayName} ${goalText}`}
          </Typography>
        }
        summaryTrailing={<PlanValidationIcon formikKeyPrefix={FORMIK_KEY_PREFIX} />}
      >
        <Box flex={1}>
          <BuilderNewPlanForm
            isLowesPension={isLowesPension}
            isTransactBond={isTransactBond}
            productProvidersOptionGroups={productProvidersOptionGroups}
            productProviders={productProviders}
            productNames={productNames}
          />
        </Box>
      </PlanAccordionShell>
    </PlanRow>
  );
};
